export const env = {
  VITE_APP_API_URL:
    (typeof window === "undefined"
      ? process.env.API_URL
      : import.meta.env.VITE_APP_API_URL) ?? "",
  VITE_APP_WS_URL:
    (typeof window === "undefined"
      ? process.env.WS_URL
      : import.meta.env.VITE_APP_WS_URL) ?? "",
  VITE_APP_WEB_ORIGIN:
    (typeof window === "undefined"
      ? process.env.VITE_APP_WEB_ORIGIN
      : import.meta.env.VITE_APP_WEB_ORIGIN) ?? "",
  VITE_APP_MAILHOG_URL:
    (typeof window === "undefined"
      ? process.env.VITE_APP_MAILHOG_URL
      : import.meta.env.VITE_APP_MAILHOG_URL) ?? "",
  VITE_APP_TURNSTILE_SITE_KEY:
    (typeof window === "undefined"
      ? process.env.VITE_APP_TURNSTILE_SITE_KEY
      : import.meta.env.VITE_APP_TURNSTILE_SITE_KEY) ?? "",
  VITE_APP_STRIPE_PUBLISHABLE_KEY:
    (typeof window === "undefined"
      ? process.env.VITE_APP_STRIPE_PUBLISHABLE_KEY
      : import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY) ?? "",
  POSTHOG_PERSONAL_API_KEY:
    (typeof window === "undefined"
      ? process.env.POSTHOG_PERSONAL_API_KEY
      : undefined) ?? "",
  PUBLIC_POSTHOG_KEY:
    (typeof window === "undefined"
      ? process.env.PUBLIC_POSTHOG_KEY
      : import.meta.env.VITE_APP_PUBLIC_POSTHOG_KEY) ?? "",
  POSTHOG_HOST:
    (typeof window === "undefined"
      ? process.env.POSTHOG_HOST
      : import.meta.env.VITE_APP_POSTHOG_HOST) ?? "",
};
